import cx from 'classnames';
import React, { useContext } from 'react';
import { RelayLogicTimeZones } from '../../../../../../../../model/DeviceAdminModel';
import { Select } from '../../../../../../../common';
import { DoorStoreSingleContext } from '../../../../../DoorModal/DoorStoreSingleContext';
import { setAutoClearAfterTimeZone, StoreContext } from '../../../../contextExpansionRelay';
import styles from '../../../../expansionRelayModal.module.scss';

type Props = {
	setPreviousSelections: (RelayLogicTimeZones) => void;
	previousSelections: RelayLogicTimeZones;
	useDoorContext: boolean;
};

const AutoClear: React.FC<Props> = props => {
	const { setPreviousSelections, previousSelections, useDoorContext } = props;
	if (useDoorContext) {
		var {
			contextStateDoor: {
				relay: { autoClearAfterTimeZones, selections, unpermitted },
			},
			dispatcherDoor,
		} = useContext(DoorStoreSingleContext);
	} else {
		var {
			expansionRelayState: { autoClearAfterTimeZones, selections, unpermitted },
			dispatcher,
		} = useContext(StoreContext);
	}

	const options = unpermitted.autoClearAfterTimeZone
		? [
				{
					label: unpermitted.autoClearAfterTimeZone.Name,
					value: unpermitted.autoClearAfterTimeZone.GenericId.toString(),
					id: `relayLogicAutoClearTimeZoneOption-${unpermitted.autoClearAfterTimeZone.GenericId.toString()}`,
				},
		  ]
		: autoClearAfterTimeZones.map(x => ({
				label: x.Name,
				value: x.GenericId.toString(),
				id: `relayLogicAutoClearTimeZoneOption-${x.GenericId.toString()}`,
		  }));

	return (
		<div className={styles.sections}>
			<span>{_('AutoClearTimezone')}</span>
			<div>
				<Select
					id='relayLogicAutoClearTimeZoneDropdown'
					className={cx(styles.select)}
					options={options}
					onChange={value => {
						if (Number(value) !== 0) {
							setPreviousSelections({ ...previousSelections, AutoClear: Number(value) });
						}

						useDoorContext ? dispatcherDoor(setAutoClearAfterTimeZone(Number(value))) : dispatcher(setAutoClearAfterTimeZone(Number(value)));
					}}
					key='autoClearTimeZone'
					value={selections.autoClearAfterTimeZone.toString()}
					disabled={unpermitted.autoClearAfterTimeZone ? true : false}
					getPopupContainer={() => document.getElementById('logicRelayContainer')}
				/>
			</div>
		</div>
	);
};

export { AutoClear };
